"use client";

import { useTina, tinaField, coloredText } from "@/lib/utils";

import Section from "@/components/Section";

import Link from "@/components/ui/link";
import CallToAction from "@/components/CallToAction";

import { Button } from "@/components/ui/button";

export default function LoginPage(props) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const { header, loginOptions, callToAction } = data.login;

  return (
    <div className="flex-1 flex flex-col">
      <Header header={header} />
      <LoginOptions loginOptions={loginOptions} />
      <CallToAction callToAction={callToAction} />
    </div>
  );
}

const Header = ({ header }) => {
  const title = coloredText(header?.title);
  return (
    <Section
      as="header"
      wrapperClassName=""
      className="flex flex-col gap-4 items-center justify-center text-center"
    >
      <h1
        data-tina-field={tinaField(header, "title")}
        className="text-balance"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p
        data-tina-field={tinaField(header, "subtitle")}
        className="max-w-[700px] p-xl text-foreground-500"
      >
        {header?.subtitle}
      </p>
    </Section>
  );
};

const LoginOptions = ({ loginOptions }) => {
  return (
    <Section
      wrapperClassName="flex-1 !pt-0 lg:!pb-32 bg-gradient-to-b from-background-blackish to-background-purplish"
      className="flex flex-col gap-12"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {loginOptions?.loginOptions?.map((loginOption, index) => (
          <div
            key={index}
            className="card bg-background-blackish flex flex-col items-center"
          >
            <h3
              className="h5 text-center"
              data-tina-field={tinaField(
                loginOptions,
                `loginOptions.${index}.title`
              )}
            >
              {loginOption?.title}
            </h3>
            <p
              className="text-foreground-500 mt-3 mb-6 text-center text-balance"
              data-tina-field={tinaField(
                loginOptions,
                `loginOptions.${index}.description`
              )}
            >
              {loginOption?.description}
            </p>
            <Button
              asChild
              data-tina-field={tinaField(
                loginOptions,
                `loginOptions.${index}.button`
              )}
            >
              <Link href={loginOption?.button?.link || "/"}>
                {loginOption?.button?.label}
              </Link>
            </Button>
          </div>
        ))}
      </div>
    </Section>
  );
};
